var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPendingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 6,
    viewBox: "0 0 20 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.20039 3.0001C5.20039 3.63662 4.94753 4.24707 4.49745 4.69715C4.04736 5.14724 3.43691 5.4001 2.80039 5.4001C2.16387 5.4001 1.55342 5.14724 1.10333 4.69715C0.653247 4.24707 0.400391 3.63662 0.400391 3.0001C0.400391 2.36358 0.653247 1.75313 1.10333 1.30304C1.55342 0.852955 2.16387 0.600098 2.80039 0.600098C3.43691 0.600098 4.04736 0.852955 4.49745 1.30304C4.94753 1.75313 5.20039 2.36358 5.20039 3.0001ZM12.4004 3.0001C12.4004 3.63662 12.1475 4.24707 11.6974 4.69715C11.2474 5.14724 10.6369 5.4001 10.0004 5.4001C9.36387 5.4001 8.75342 5.14724 8.30334 4.69715C7.85325 4.24707 7.60039 3.63662 7.60039 3.0001C7.60039 2.36358 7.85325 1.75313 8.30334 1.30304C8.75342 0.852955 9.36387 0.600098 10.0004 0.600098C10.6369 0.600098 11.2474 0.852955 11.6974 1.30304C12.1475 1.75313 12.4004 2.36358 12.4004 3.0001ZM17.2004 5.4001C17.8369 5.4001 18.4474 5.14724 18.8974 4.69715C19.3475 4.24707 19.6004 3.63662 19.6004 3.0001C19.6004 2.36358 19.3475 1.75313 18.8974 1.30304C18.4474 0.852955 17.8369 0.600098 17.2004 0.600098C16.5639 0.600098 15.9534 0.852955 15.5033 1.30304C15.0532 1.75313 14.8004 2.36358 14.8004 3.0001C14.8004 3.63662 15.0532 4.24707 15.5033 4.69715C15.9534 5.14724 16.5639 5.4001 17.2004 5.4001Z",
    fill: "#118AB2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/pendingIcon.05d8a230acbb5812f9ffc94e23f29790.svg";
export { ForwardRef as ReactComponent };